var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.95H2.33333M2.33333 3.95H13M2.33333 3.95V13.4C2.33333 13.758 2.47381 14.1014 2.72386 14.3546C2.97391 14.6078 3.31304 14.75 3.66667 14.75H10.3333C10.687 14.75 11.0261 14.6078 11.2761 14.3546C11.5262 14.1014 11.6667 13.758 11.6667 13.4V3.95H2.33333ZM4.33333 3.95V2.6C4.33333 2.24196 4.47381 1.89858 4.72386 1.64541C4.97391 1.39223 5.31304 1.25 5.66667 1.25H8.33333C8.68696 1.25 9.02609 1.39223 9.27614 1.64541C9.52619 1.89858 9.66667 2.24196 9.66667 2.6V3.95M5.66667 7.325V11.375M8.33333 7.325V11.375",
    stroke: "#FF4242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrashIcon);
export default __webpack_public_path__ + "static/media/redTrashIcon.d22e15eef0427e9405bdbbb43d7b2185.svg";
export { ForwardRef as ReactComponent };